import './App.css';
import 'react-toastify/dist/ReactToastify.css';
import { Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import ProtectedRoute from './Components/Secure/ProtectedRoute';
import GuestRoute from './Components/Secure/GuestRoute';

import Home from './Pages/Home/Home';
import News from './Pages/News/News';
import SelectedNews from './Pages/News/SelectedNews';
import Composition from './Pages/Composition/Composition';
import Thumbnail from './Pages/Thumbnail/Thumbnail';
import CompletedVids from './Pages/Completed/CompletedVids';
import CompletedVideo from './Pages/Completed/CompletedVideo';
import Drafts from './Pages/Drafts/Drafts';
import CompletedDrafts from './Pages/Drafts/CompletedDrafts';
import ProcessingDrafts from './Pages/Drafts/ProcessingDrafts';
import Voices from './Pages/Voices/Voices';
import Background from './Pages/Voices/Background';
import Signin from './Pages/Signin/Signin';
import Signup from './Pages/Signup/Signup';
import Channel from './Pages/Channels/Channel';
import Timeline from './Pages/Timeline/Timeline';
import NotFound from './Components/NotFound/NotFound';
import TalkingHeadsStudio from './Pages/Composition/TalkingHeadsStudio';
import BillboardCalculator from './Pages/Billboard/BillboardCalculator';
import AdminRoute from './Components/Secure/AdminRoute';
import PipelineControl from './Pages/Admin/PipelineControl';
import DocumentaryList from './Pages/Documentaries/DocumentaryList';
import NewDocumentary from './Pages/Documentaries/NewDocumentary';
import DocumentaryProject from './Pages/Documentaries/DocumentaryProject';
import BrandKits from './Pages/Documentaries/BrandKits';
import TimelineEditor from './Pages/Documentaries/TimelineEditor';

function App() {
  return (
    <div className="App">
      <ToastContainer />
      <Routes>

        {/* ── Public: only accessible when logged OUT ──────────── */}
        <Route path="/login" element={
          <GuestRoute><Signin /></GuestRoute>
        } />

        <Route path="/bill" element={
          <GuestRoute><BillboardCalculator/></GuestRoute>
        } />

        {/* ── Protected: require authentication ────────────────── */}

        <Route path="/" element={
          <ProtectedRoute><Home /></ProtectedRoute>
        } />
       <Route path="/sign-up" element={
          <ProtectedRoute><Signup /></ProtectedRoute>
        } />
        <Route path="/news" element={
          <ProtectedRoute><News /></ProtectedRoute>
        } />
        <Route path="/news-script/:newsId" element={
          <ProtectedRoute><SelectedNews /></ProtectedRoute>
        } />

        <Route path="/compose/:vDataId" element={
          <ProtectedRoute><Composition /></ProtectedRoute>
        } />

        <Route path="/dreamface/:jobId" element={<TalkingHeadsStudio />} />

        <Route path="/timeline" element={
          <ProtectedRoute><Timeline /></ProtectedRoute>
        } />

        <Route path="/thumbnail" element={
          <ProtectedRoute><Thumbnail /></ProtectedRoute>
        } />

        <Route path="/drafts" element={
          <ProtectedRoute><Drafts /></ProtectedRoute>
        } />
        <Route path="/completed-drafts" element={
          <ProtectedRoute><CompletedDrafts /></ProtectedRoute>
        } />
        <Route path="/processing-drafts" element={
          <ProtectedRoute><ProcessingDrafts /></ProtectedRoute>
        } />

        <Route path="/voices" element={
          <ProtectedRoute><Voices /></ProtectedRoute>
        } />
        <Route path="/background" element={
          <ProtectedRoute><Background /></ProtectedRoute>
        } />

        <Route path="/channels" element={
          <ProtectedRoute><Channel /></ProtectedRoute>
        } />

        <Route path="/completed/" element={
          <ProtectedRoute><CompletedVids /></ProtectedRoute>
        } />
        <Route path="/completed/:id" element={
          <ProtectedRoute><CompletedVideo /></ProtectedRoute>
        } />

        <Route path="/documentaries" element={
          <ProtectedRoute><DocumentaryList /></ProtectedRoute>
        } />
        <Route path="/documentaries/new" element={
          <ProtectedRoute><NewDocumentary /></ProtectedRoute>
        } />
        <Route path="/documentaries/brand-kits" element={
          <ProtectedRoute><BrandKits /></ProtectedRoute>
        } />
        <Route path="/documentaries/:id/timeline" element={
          <ProtectedRoute><TimelineEditor /></ProtectedRoute>
        } />
        <Route path="/documentaries/:id" element={
          <ProtectedRoute><DocumentaryProject /></ProtectedRoute>
        } />

        <Route path="/admin/pipeline" element={
          <ProtectedRoute>
            <AdminRoute><PipelineControl /></AdminRoute>
          </ProtectedRoute>
        } />

        {/* ── 404 catch-all ────────────────────────────────── */}
        <Route path="*" element={<NotFound />} />

      </Routes>
    </div>
  );
}

export default App;